import {
  Alert,
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Toggle,
  Typography,
} from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { IPHTableSettingsDrawer } from '../../../models/purchase-history/table';
import { getWindow } from '../../../utils/general';

export const PHTableSettingsDrawer = ({
  enableSettingsDrawer,
  setEnableSettingsDrawer,
  tableHeaderState,
  setTableHeaderState,
}: IPHTableSettingsDrawer) => {
  const [showAlert, setShowAlert] = useState(false);
  const [tableHeaders, setTableHeaders] = useState(tableHeaderState);

  const handleToggle = (index: number) => {
    setTableHeaders((prevState) => {
      const updatedHeaders = [...prevState];
      updatedHeaders[index] = {
        ...updatedHeaders[index],
        enabled: !updatedHeaders[index].enabled,
      };
      return updatedHeaders;
    });
  };

  const closeModal = () => setEnableSettingsDrawer(false);

  const handleApply = () => {
    const hasAtLeastOneEnabled = tableHeaders.some(
      (header) => header.enabled === true,
    );
    if (!hasAtLeastOneEnabled) {
      setShowAlert(true);
      return;
    }
    const tableStringify = JSON?.stringify(tableHeaders);
    getWindow()?.sessionStorage.setItem('tableHeaders', tableStringify);
    setTableHeaderState(tableHeaders);
    closeModal();
  };

  return (
    <div className="sui-relative sui-outline-0 sui-m-auto sui-flex sui-gap-4 sui-justify-center sui-pt-4 sui-pb-28 sui-h-[600px]">
      <>
        <Drawer
          open={enableSettingsDrawer}
          onClose={closeModal}
          position="right"
        >
          <DrawerHeader title="Customize Table" onClose={closeModal} />
          <DrawerBody>
            <div className="sui-mb-[29px]">
              <Typography variant="body-base">
                Select the columns you would like to see in Tableview:
              </Typography>
            </div>
            {showAlert && (
              <Alert status="error" size="large">
                You must make at least one selection.
              </Alert>
            )}
            <div className="sui-flex sui-flex-col sui-gap-[12px]">
              {tableHeaders.map((header, index) => {
                if (header?.showToggle === false) {
                  return null;
                }

                return (
                  <button
                    key={index}
                    type="button"
                    className="sui-flex sui-items-center sui-gap-[16px] sui-bg-transparent sui-border-0 sui-p-0 sui-text-left sui-cursor-pointer"
                    onClick={() => handleToggle(index)}
                    aria-pressed={header?.enabled ?? false}
                  >
                    <Toggle
                      checked={header?.enabled ?? false}
                      inputAttributes={{ 'aria-label': 'controlled' }}
                    />{' '}
                    <Typography variant="body-base">
                      {header?.columnName ?? ''}
                    </Typography>
                  </button>
                );
              })}
            </div>
          </DrawerBody>
          <DrawerFooter>
            <div className="ButtonGroup sui-flex sui-flex-col sui-gap-2">
              <Button fullWidth onClick={handleApply}>
                Apply
              </Button>
              <Button variant="secondary" fullWidth onClick={closeModal}>
                Cancel
              </Button>
            </div>
          </DrawerFooter>
        </Drawer>
      </>
    </div>
  );
};
